import React from 'react';
import { connect } from 'react-redux';
import { create } from './../Actions/newsSource';
import Routes from './../Shared/routes';
import AddNewsSource from '../Components/NewsSource/Item';
import { stat } from 'fs';
import { FILL_PARAMS_ERROR } from '../Shared/errors';


interface IProps {
    isLoading: boolean;
    error: number;
    create: (title: string, link: string, status: number) => void;
    history: any;
}

interface IState {
    error: number | null;
}

class AddNewsSourcePage extends React.Component<IProps, IState> {

    state = {
        error: null
    }

    onSubmit = async (title: string, link: string, status: number) => {
        if (!(title && link && status)) {
            this.setState({
                error: FILL_PARAMS_ERROR
            })
        }
        else {
            await this.props.create(title, link, status);
            if (!this.props.error) {
                this.props.history.push(Routes.NEWS_SOURCE_LIST)
            }
        }
    }

    render() {
        return (
            <AddNewsSource
                error={this.props.error || this.state.error}
                isLoading={this.props.isLoading}
                onSubmit={this.onSubmit}
            />
        );
    }
}

function bindAction(dispatch: any) {
    return {
        create: (title: string, link: string, status: number) => dispatch(create(title, link, status))
    };
}

const mapStateToProps = (state: any) => {
    return {
        isLoading: state.newsSource.isLoading,
        error: state.newsSource.error
    }
}

export default connect(
    mapStateToProps,
    bindAction
)(AddNewsSourcePage);
